import { MCPConfiguration, ReportColumn } from "@/types/evaluate";
import { ReactNode, useState } from "react";
import ServerConnectStep from "@/components/Evaluate/TableComponents/NewColumnModal/MCPType/ServerConnectStep";
import HomeStep from "@/components/Evaluate/TableComponents/NewColumnModal/MCPType/HomeStep";
import { displayErrorToast } from "@/utils/toast";

const MCPBuilder = ({
  columnData,
  patchColumnData,
  navigatePrevious,
  availableColumns,
  saveColumnAction,
  editable,
}: {
  columnData: Partial<ReportColumn>;
  patchColumnData: (
    data:
      | Partial<ReportColumn>
      | ((prevState: Partial<ReportColumn>) => Partial<ReportColumn>),
  ) => void;
  navigatePrevious: () => void;
  availableColumns: Array<ReportColumn>;
  saveColumnAction: (newColumnDataArg: ReportColumn) => void;
  editable: boolean;
}) => {
  const setConfiguration = (
    data:
      | Partial<MCPConfiguration>
      | ((prevState: Partial<MCPConfiguration>) => Partial<MCPConfiguration>),
  ) => {
    if (editable) {
      if (typeof data === "function") {
        patchColumnData((prevState) => {
          return {
            ...prevState,
            configuration: data(prevState?.configuration || {}),
          };
        });
      } else {
        patchColumnData({ configuration: data });
      }
    }
  };

  const saveMcpConfiguration = () => {
    saveColumnAction(columnData as ReportColumn);
  };

  const [currentNavigation, setCurrentNavigation] = useState(
    columnData.configuration?.server_configuration?.server_url
      ? "home"
      : "server-connect",
  );

  const builderNavigation: { [key: string]: () => ReactNode } = {
    home: () => (
      <HomeStep
        navigateAway={saveMcpConfiguration}
        setCurrentNavigation={setCurrentNavigation}
        availableColumns={availableColumns}
        configuration={columnData.configuration}
        setConfiguration={setConfiguration}
        columnName={columnData.name || ""}
        setColumnName={(name: string) => patchColumnData({ name })}
        editable={editable}
      />
    ),
    "server-connect": () => (
      <ServerConnectStep
        navigateAway={() => {
          if (columnData.configuration.server_configuration?.server_url) {
            setCurrentNavigation("home");
          } else {
            displayErrorToast("Missing server url");
          }
        }}
        configuration={columnData.configuration as Partial<MCPConfiguration>}
        setConfiguration={setConfiguration}
        editable={editable}
      />
    ),
  };

  return builderNavigation[currentNavigation]();
};

export default MCPBuilder;
